import React from 'react';
import { Link } from 'react-router-dom';
import { SuiteIcon } from '@shared/icons';
import { useActiveSuite } from '../useActiveSuite';

export const ActiveAppLabel: React.FC = () => {
  const activeSuite = useActiveSuite();

  if (!activeSuite) {
    return (
      <Link
        to="/"
        className="flex items-center gap-1.5 px-2 py-1 text-xs font-semibold text-navbar-foreground hover:text-white transition-colors"
      >
        <SuiteIcon name="layout-grid" className="h-4 w-4 text-navbar-muted" />
        <span className="hidden sm:inline">Overview</span>
      </Link>
    );
  }

  return (
    <Link
      to={activeSuite.basePath}
      className="flex items-center gap-1.5 px-2 py-1 text-xs font-semibold text-navbar-foreground hover:text-white transition-colors"
      title={`Active Suite: ${activeSuite.name}`}
    >
      <SuiteIcon name={activeSuite.icon} className="h-4 w-4 text-primary" />
      <span className="hidden sm:inline tracking-tight">{activeSuite.name}</span>
    </Link>
  );
};
